/* ============
 * Auth
 * ============
 *
 * Auth0 authentication
 */

import Vue from 'vue'
import auth0 from 'auth0-js'
import Cookies from 'js-cookie'
import decode from 'jwt-decode'

import {emitter, events} from '../../emitter'

export const AUTH_SESSION_COOKIE_NAME =
  process.env.AUTH_SESSION_COOKIE_NAME

export const AUTH_SESSION_DOMAIN = /localhost/.test(window.location.hostname)
  ? 'localhost'
  : 'tuango.ca'

// check session every ... ms
export const CHECK_SESSION_INTERVAL = 15 * 1000

// cookie ttl in ms
export const AUTH_SESSION_COOKIE_TTL = 90 * 60 * 1000

// renew token before expiration (in ms)
export const RENEW_TOKEN_BEFORE = 15 * 60 * 1000

const authClient = new auth0.WebAuth({
  domain: process.env.AUTH0_DOMAIN,
  clientID: process.env.AUTH0_CLIENT_ID,
  redirectUri: process.env.AUTH0_REDIRECT_URL,
  responseType: process.env.AUTH0_RESPONSE_TYPE,
  scope: process.env.AUTH0_SCOPE
})

const Auth = {
  login () {
    authClient.authorize()
  },

  getUserSession () {
    const session = Cookies.getJSON(AUTH_SESSION_COOKIE_NAME)

    if (!session) return false

    const decoded = decode(session)
    const tokenExpiresAt = decoded['exp'] * 1000

    return {
      idToken: session,
      userInfo: decoded,
      expiresAt: tokenExpiresAt
    }
  },

  /**
   * @param idToken
   * @param {Number|Date} expires Cookie TTL
   */
  createSession (idToken, expires = 30) {
    Cookies.set(AUTH_SESSION_COOKIE_NAME, idToken, {
      expires: expires,
      domain: AUTH_SESSION_DOMAIN,
      secure: window.location.protocol === 'https:'
    })
  },

  clearSession () {
    Cookies.remove(AUTH_SESSION_COOKIE_NAME, {
      domain: AUTH_SESSION_DOMAIN
    })
  },

  renew () {
    return new Promise((resolve, reject) => {
      authClient.checkSession({}, (err, result) => {
        if (err || result.error) {
          const error = err || result.error
          reject(error)
        } else if (result) {
          resolve(result)
        }
      })
    })
  },

  authenticate () {
    return new Promise((resolve, reject) => {
      authClient.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          resolve(authResult)
        } else if (err) {
          reject(err)
        } else {
          reject(new Error('Authentication error.'))
        }
      })
    })
  },

  logout (returnTo = null) {
    authClient.logout({
      federated: false,
      clientID: process.env.AUTH0_CLIENT_ID,
      returnTo: returnTo || process.env.AUTH0_LOGOUT_URL
    })
  }
}

Vue.$auth = Auth
Object.defineProperty(Vue.prototype, '$auth', {
  get () {
    return Auth
  }
})

// Create session timer
class SessionTimer {
  constructor () {
    this.id = null
  }

  start () {
    this.stop()
    this.id = window.setInterval(() => {
      emitter.$emit(events.SESSION_CHECK)
    }, CHECK_SESSION_INTERVAL)
  }

  stop () {
    window.clearInterval(this.id)
  }
}

const timer = new SessionTimer()
timer.start()



// WEBPACK FOOTER //
// ./src/app/plugins/auth.js